import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { getPayments } from "../lib/api";
import { daysLate, money, fmtDay } from "../lib/payments";

const LABEL = { carrier_1: "1st half", carrier_2: "2nd half" };

export const OverduePaymentsBanner = ({ refreshKey, onOpen }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () => getPayments().then(({ data }) => {
      if (!alive) return;
      const list = [];
      for (const p of data) {
        for (const part of ["carrier_1", "carrier_2"]) {
          const info = p.parts[part];
          const late = info.paid_at ? 0 : daysLate(info.due_date);
          if (late > 3) list.push({ key: `${p.id}-${part}`, p, part, info, late });
        }
      }
      setItems(list.sort((a, b) => b.late - a.late));
    }).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, [refreshKey]);

  if (!items.length) return null;
  const total = items.reduce((s, i) => s + (i.info.total_due || i.info.amount || 0), 0);

  return (
    <div data-testid="overdue-payments-banner" className="mb-4 bg-red-950/30 border border-red-600/50 rounded-md px-4 py-3">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <AlertTriangle className="h-4 w-4 text-red-400" />
        <span className="font-heading font-bold uppercase tracking-wide text-red-300 text-sm">
          Carrier payments overdue 3+ days ({items.length}) · {money(total)}
        </span>
      </div>
      <ul className="space-y-1">
        {items.map(({ key, p, part, info, late }) => (
          <li key={key}>
            <button data-testid={`overdue-payment-item-${key}`} onClick={onOpen}
              className="w-full text-left flex flex-wrap items-baseline justify-between gap-x-3 text-xs rounded px-2 py-1 hover:bg-red-950/50">
              <span className="text-white">
                <b>{p.carrier_name || "Carrier not set"}</b> · {p.driver_name} · {LABEL[part]}
              </span>
              <span className="font-mono text-red-300">
                {money(info.amount)}{info.late_fee ? ` + ${money(info.late_fee)} fee` : ""} · due {fmtDay(info.due_date)} · {late} days late
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
